store.message = {};
store.message.add = function (msg, title, img, cssClass, action) {
	// @todo make pretty
	if (title === undefined || title === null) {
		title = 'Store';
	}
	if (msg === undefined || msg === null) {
		msg = '&nbsp';
	}
	if (cssClass === undefined || cssClass === null) {
		cssClass = 'normal';
	}
	if (action === undefined || action === null) {
		action = 'undefined';
	}
	var options = {
		title: title,
		text: msg,
		sticky: false,
		class_name: cssClass,
		action: action
	};
	if (undefined !== img) {
		options.image = img;
	}
	store.message.showMessage(options);
};

store.message.showMessage = function (options) {
	if (store.local.showMessage) {
		store.local.showMessage(options)
	}
	else {
		store.message.showGritter(options);
	}
};

store.message.showGritter = function (options) {
	if ($.gritter) {
		$.gritter.add(options);
	}
};

store.message.error = function (msg, title, img, action) {
	store.message.add(msg, title, img, 'error', action);
};
